import LoginPage from '../pages/LoginPage';
import SnapSharedPage from '../pages/SnapSharedPage';
import WelcomePage from '../pages/WelcomePage';
import DomainMissingPage from '../pages/DomainMissingPage';
import JoinPage from '../pages/JoinPage';
import AwaitingApprovePage from '../pages/AwaitingApprovePage';
import SettingsPage from '../pages/SettingsPage';
import MyBoardsPage from '../pages/MyBoardsPage';
import TeamRoomsPage from '../pages/TeamRoomsPage';
import AskPage from '../pages/AskPage';

const routes = [
	{
		path: '/login',
		exact: true,
		isPublic: true,
		component: LoginPage,
	},
	{
		path: '/login/:token',
		exact: true,
		isPublic: true,
		component: LoginPage,
	},
	{
		path: '/snap/shared/:token',
		exact: true,
		isPublic: true,
		component: SnapSharedPage,
	},
	{
		path: '/welcome',
		exact: true,
		isPublic: false,
		component: WelcomePage,
	},
	{
		path: '/domain-missing',
		exact: true,
		isPublic: false,
		component: DomainMissingPage,
	},
	{
		path: '/join',
		exact: true,
		isPublic: false,
		component: JoinPage,
	},
	{
		path: '/awaiting-approve',
		exact: true,
		isPublic: false,
		component: AwaitingApprovePage,
	},
	{
		path: '/settings',
		exact: false,
		isPublic: false,
		component: SettingsPage,
	},
	{
		path: '/my-boards',
		exact: true,
		isPublic: false,
		component: MyBoardsPage,
	},
	{
		path: '/team-rooms',
		exact: true,
		isPublic: false,
		component: TeamRoomsPage,
	},
	{
		path: '/ask',
		exact: true,
		isPublic: false,
		component: AskPage,
	},
];

export default routes;
